(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nola-announce]').forEach((bar) => {
      if (bar.__nolaAnnounceInit) return;
      bar.__nolaAnnounceInit = true;
      const items = Array.from(bar.querySelectorAll('[data-nola-announce-item]'));
      if (items.length < 2) return;
      const interval = Math.max(1500, Number(bar.dataset.interval) || 4000);
      const fade = Math.max(120, Number(bar.dataset.fade) || 500);
      let i = 0;

      const advance = () => {
        const current = items[i];
        const next = items[(i + 1) % items.length];
        current.classList.add('is-leaving');
        current.classList.remove('is-active');
        next.classList.add('is-active');
        setTimeout(() => current.classList.remove('is-leaving'), fade);
        i = (i + 1) % items.length;
      };

      let timer = setInterval(advance, interval);
      // Pause when the tab isn't visible to save cycles.
      document.addEventListener('visibilitychange', () => {
        clearInterval(timer);
        if (!document.hidden) timer = setInterval(advance, interval);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nolaFooterInit) return;
    window.__nolaFooterInit = true;
    const mq = window.matchMedia('(min-width: 750px)');

    const openDisclosures = () => {
      if (!mq.matches) return;
      document.querySelectorAll('.nola-footer__disclosure').forEach((d) => {
        d.setAttribute('open', '');
      });
    };

    // Move the standalone newsletter section into the footer on desktop.
    // A comment node is left at the original location so we can move it back
    // if the viewport drops below the breakpoint.
    let newsletterPlaceholder = null;
    const placeNewsletter = () => {
      const slot = document.querySelector('[data-nola-footer-newsletter-slot]');
      const newsletter = document.querySelector('.nola-newsletter');
      if (!slot || !newsletter) return;

      if (mq.matches) {
        if (newsletter.parentElement !== slot) {
          if (!newsletterPlaceholder) {
            newsletterPlaceholder = document.createComment('nola-newsletter-original-pos');
            newsletter.parentNode.insertBefore(newsletterPlaceholder, newsletter);
          }
          slot.appendChild(newsletter);
        }
      } else if (newsletterPlaceholder && newsletter.parentElement === slot) {
        newsletterPlaceholder.parentNode.insertBefore(newsletter, newsletterPlaceholder);
      }
    };

    const apply = () => { openDisclosures(); placeNewsletter(); };

    apply();
    mq.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setActivePanel(stack, handle) {
      const panels = stack.querySelectorAll('.nola-drawer__panel');
      panels.forEach((p) => p.classList.remove('is-active', 'is-back'));
      const target = stack.querySelector(`[data-panel="${handle}"]`);
      if (!target) return;
      target.classList.add('is-active');
      // Walk up the parent chain — each ancestor gets is-back so the slide animation reads.
      let parentHandle = target.dataset.parent;
      while (parentHandle) {
        const parentEl = stack.querySelector(`[data-panel="${parentHandle}"]`);
        if (!parentEl) break;
        parentEl.classList.add('is-back');
        parentHandle = parentEl.dataset.parent;
      }
      if (handle !== 'root') {
        const root = stack.querySelector('[data-panel="root"]');
        if (root) root.classList.add('is-back');
      }
    }

    document.querySelectorAll('[data-nola-drawer-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('aria-controls');
        const dlg = id && document.getElementById(id);
        if (!dlg || typeof dlg.showModal !== 'function') return;
        const stack = dlg.querySelector('[data-nola-drawer-stack]');
        if (stack) setActivePanel(stack, 'root');
        dlg.showModal();
      });
    });
    document.querySelectorAll('[data-nola-drawer-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dlg = btn.closest('dialog');
        if (dlg) dlg.close();
      });
    });
    document.querySelectorAll('dialog.nola-drawer').forEach((dlg) => {
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg) dlg.close();
      });
    });

    // Subpanel slide navigation
    document.addEventListener('click', (e) => {
      const goBtn = e.target.closest('[data-nola-drawer-go]');
      if (goBtn) {
        e.preventDefault();
        const target = goBtn.getAttribute('data-nola-drawer-go');
        const stack = goBtn.closest('[data-nola-drawer-stack]');
        if (stack && target) setActivePanel(stack, target);
        return;
      }
      const backBtn = e.target.closest('[data-nola-drawer-back]');
      if (backBtn) {
        const stack = backBtn.closest('[data-nola-drawer-stack]');
        if (!stack) return;
        const current = backBtn.closest('.nola-drawer__panel');
        const parent = (current && current.dataset.parent) || 'root';
        setActivePanel(stack, parent);
      }
    });

    // Cart drawer helper — exposed on window so ATC handlers in other
    // sections can open the drawer reliably even if the cart:update event
    // fires before <cart-drawer-component> has been upgraded.
    const openCartDrawer = () => {
      const el = document.querySelector('cart-drawer-component');
      if (!el) return false;
      const tryOpen = () => {
        if (typeof el.open === 'function') {
          el.open();
        } else {
          el.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
        }
      };
      if (window.customElements?.get('cart-drawer-component')) {
        tryOpen();
      } else {
        window.customElements?.whenDefined('cart-drawer-component').then(tryOpen);
      }
      return true;
    };
    window.NolaCart = window.NolaCart || {};
    window.NolaCart.open = openCartDrawer;

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-nola-cart-toggle]');
      if (!btn) return;
      e.preventDefault();
      openCartDrawer();
    });

    // Live cart count update — listens for nola:cart:updated dispatched by quick-add.
    document.addEventListener('nola:cart:updated', (e) => {
      const count = e.detail?.item_count ?? 0;
      document.querySelectorAll('.nola-header__cart').forEach((cart) => {
        let badge = cart.querySelector('.nola-header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'nola-header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            cart.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nolaCollInit) return;
    window.__nolaCollInit = true;

    const moneyFormat = (cents) => {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
      } catch {
        return (cents / 100).toFixed(2);
      }
    };

    /* ---------- Filter dialog ---------- */
    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-nola-filter-open]');
      if (openBtn) {
        const id = openBtn.getAttribute('aria-controls');
        const dlg = id && document.getElementById(id);
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
        return;
      }
      const closeBtn = e.target.closest('[data-nola-filter-close]');
      if (closeBtn) {
        const dlg = closeBtn.closest('dialog');
        if (dlg) dlg.close();
        return;
      }
    });
    document.querySelectorAll('dialog.nola-filter').forEach((dlg) => {
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg) dlg.close();
      });
    });

    /* Wishlist behavior is handled globally by assets/nola-wishlist.js */

    const updateGalleryDots = (gallery) => {
      const dots = gallery.closest('.nola-card__media-wrap')?.querySelectorAll('.nola-card__gallery-dot');
      if (!dots || dots.length < 2) return;
      const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    /* Enable click-drag swiping on desktop. Touch devices keep their native swipe. */
    const enableDragScroll = (gallery) => {
      gallery.querySelectorAll('img').forEach((img) => { img.draggable = false; });
      // The browser's native image/link drag creates the "ghost image" bug — kill it.
      gallery.addEventListener('dragstart', (e) => e.preventDefault());

      let isDown = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;
      const THRESHOLD = 4;

      gallery.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = gallery.scrollLeft;
        gallery.classList.add('is-dragging');
        try { gallery.setPointerCapture(e.pointerId); } catch (_) {}
      });

      gallery.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > THRESHOLD) moved = true;
        if (moved) {
          gallery.scrollLeft = startScroll - dx;
          e.preventDefault();
        }
      });

      const finish = (e) => {
        if (!isDown) return;
        isDown = false;
        gallery.classList.remove('is-dragging');
        try { gallery.releasePointerCapture(e.pointerId); } catch (_) {}
        if (moved) {
          // Snap to the nearest slide after a drag.
          const w = gallery.clientWidth || 1;
          const index = Math.round(gallery.scrollLeft / w);
          gallery.scrollTo({ left: index * w, behavior: 'smooth' });
        }
      };
      gallery.addEventListener('pointerup', finish);
      gallery.addEventListener('pointercancel', finish);

      // A drag must not also trigger the card link navigation.
      const link = gallery.closest('a');
      if (link) {
        link.addEventListener('click', (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        }, true);
      }
    };

    const slideWidth = (gallery) => gallery.clientWidth || 1;
    const slideCount = (gallery) => gallery.querySelectorAll('[data-nola-card-slide]').length;
    const currentIndex = (gallery) => Math.round(gallery.scrollLeft / slideWidth(gallery));

    /* Hide the prev arrow on the first image and the next arrow on the last. */
    const updateNavButtons = (gallery) => {
      const wrap = gallery.closest('.nola-card__media-wrap');
      if (!wrap) return;
      const prev = wrap.querySelector('[data-nola-card-prev]');
      const next = wrap.querySelector('[data-nola-card-next]');
      const index = currentIndex(gallery);
      const last = slideCount(gallery) - 1;
      if (prev) prev.hidden = index <= 0;
      if (next) next.hidden = index >= last;
    };

    const initGalleries = (root = document) => {
      root.querySelectorAll('[data-nola-card-gallery]').forEach((gallery) => {
        if (gallery.dataset.nolaGalleryInit === 'true') return;
        gallery.dataset.nolaGalleryInit = 'true';
        gallery.addEventListener('scroll', () => {
          window.requestAnimationFrame(() => {
            updateGalleryDots(gallery);
            updateNavButtons(gallery);
          });
        }, { passive: true });
        updateGalleryDots(gallery);
        updateNavButtons(gallery);
        enableDragScroll(gallery);
      });
    };
    initGalleries();

    /* Card gallery arrows (desktop pointer devices). */
    document.addEventListener('click', (e) => {
      const nav = e.target.closest('[data-nola-card-prev], [data-nola-card-next]');
      if (!nav) return;
      e.preventDefault();
      e.stopPropagation();
      const wrap = nav.closest('.nola-card__media-wrap');
      const gallery = wrap && wrap.querySelector('[data-nola-card-gallery]');
      if (!gallery) return;
      const dir = nav.hasAttribute('data-nola-card-next') ? 1 : -1;
      const last = slideCount(gallery) - 1;
      const target = Math.min(Math.max(currentIndex(gallery) + dir, 0), last);
      gallery.scrollTo({ left: target * slideWidth(gallery), behavior: 'smooth' });
    });

    /* ---------- Add to cart (adds AND refreshes the cart drawer section) ---------- */
    const nolaCartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ? Theme.routes.cart_add_url : '/cart/add.js';
    const nolaAddToCart = async (variantId, meta) => {
      const sectionEl = document.querySelector('cart-items-component[data-section-id]');
      const sectionId = sectionEl && sectionEl.dataset.sectionId;
      const body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
      const addRes = await fetch(nolaCartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await addRes.json();
      if (!addRes.ok || data.errors) throw new Error(data.description || 'Add to cart failed');
      // Replace the cart drawer's contents with the freshly rendered section so the item shows.
      if (sectionId && data.sections && data.sections[sectionId]) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data.sections[sectionId];
        const fresh = tmp.querySelector('cart-items-component[data-section-id]');
        if (fresh && sectionEl) sectionEl.replaceWith(fresh);
      }
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      window.NolaPostHog?.trackAddToCart({ addedItem: { variant_id: variantId, product_id: meta && meta.productId, product_title: meta && meta.productTitle, quantity: 1 }, cart, addedFrom: 'quick_add' });
      document.dispatchEvent(new CustomEvent('nola:cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, data: { source: 'nola-collection-quick-add', sections: data.sections } } }));
      window.NolaCart?.open();
      return cart;
    };

    /* ---------- Quick add (single-variant) ---------- */
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('button[data-nola-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      try {
        await nolaAddToCart(variantId, { productId: btn.dataset.productId, productTitle: btn.dataset.productTitle });
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1500);
      } catch (err) {
        console.error('[nola] quick-add error', err);
      } finally {
        btn.disabled = false;
      }
    });

    /* ---------- Quick Add modal ---------- */
    const qa = document.querySelector('[data-nola-qa]');
    const qaImage = qa && qa.querySelector('[data-nola-qa-image]');
    const qaTitle = qa && qa.querySelector('[data-nola-qa-title]');
    const qaPrice = qa && qa.querySelector('[data-nola-qa-price]');
    const qaOptions = qa && qa.querySelector('[data-nola-qa-options]');
    const qaAdd = qa && qa.querySelector('[data-nola-qa-add]');
    const qaDetails = qa && qa.querySelector('[data-nola-qa-details]');
    const qaMsg = qa && qa.querySelector('[data-nola-qa-msg]');
    let qaProduct = null;
    let qaOptCount = 0;
    let qaOptNames = [];
    let qaValuesByIndex = [];
    let qaSelected = [];
    let qaColorIdx = -1;
    let qaColorImg = {};

    const openQa = () => { if (qa) { qa.hidden = false; document.body.style.overflow = 'hidden'; } };
    const closeQa = () => { if (qa) { qa.hidden = true; document.body.style.overflow = ''; } };
    if (qa) {
      qa.addEventListener('click', (e) => { if (e.target.closest('[data-nola-qa-close]')) closeQa(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !qa.hidden) closeQa(); });
    }

    const isColorName = (name) => { const n = (name || '').toLowerCase(); return n === 'color' || n === 'colour'; };

    const valueAvailable = (idx, value) => qaProduct.variants.some((v) => {
      if (!v.available || v.options[idx] !== value) return false;
      for (let i = 0; i < qaOptCount; i++) {
        if (i !== idx && qaSelected[i] != null && v.options[i] !== qaSelected[i]) return false;
      }
      return true;
    });

    const matchedVariant = () => {
      if (qaSelected.some((s) => s == null)) return null;
      return qaProduct.variants.find((v) => v.options.every((o, i) => o === qaSelected[i])) || null;
    };

    const updateQaImage = () => {
      if (!qaImage) return;
      let src = qaProduct.featured_image || '';
      if (qaColorIdx >= 0 && qaSelected[qaColorIdx] != null && qaColorImg[qaSelected[qaColorIdx]]) {
        src = qaColorImg[qaSelected[qaColorIdx]];
      } else {
        const mv = matchedVariant();
        if (mv && mv.featured_image && mv.featured_image.src) src = mv.featured_image.src;
      }
      if (src) qaImage.src = src;
    };

    const renderQa = () => {
      qaOptions.innerHTML = '';
      qaOptNames.forEach((name, idx) => {
        const group = document.createElement('div');
        group.className = 'nola-qa__group';
        const lbl = document.createElement('span');
        lbl.className = 'nola-qa__group-label';
        lbl.textContent = (idx === qaColorIdx && qaSelected[idx]) ? (name + ': ' + qaSelected[idx]) : name;
        group.appendChild(lbl);
        const row = document.createElement('div');
        row.className = (idx === qaColorIdx) ? 'nola-qa__swatches' : 'nola-qa__values';
        qaValuesByIndex[idx].forEach((value) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.dataset.optIdx = idx;
          b.dataset.optValue = value;
          if (idx === qaColorIdx) {
            b.className = 'nola-qa__swatch';
            b.title = value;
            b.setAttribute('aria-label', value);
            if (qaColorImg[value]) b.style.backgroundImage = 'url(' + qaColorImg[value] + ')';
          } else {
            b.className = 'nola-qa__chip';
            b.textContent = value;
          }
          if (qaSelected[idx] === value) b.classList.add('is-selected');
          if (!valueAvailable(idx, value)) { b.classList.add('is-soldout'); b.disabled = true; }
          row.appendChild(b);
        });
        group.appendChild(row);
        qaOptions.appendChild(group);
      });
      const mv = matchedVariant();
      qaAdd.disabled = !(mv && mv.available);
      qaAdd.textContent = qaSelected.some((s) => s == null) ? 'Select options' : (mv && mv.available ? 'Add to bag' : 'Unavailable');
      updateQaImage();
    };

    const openModalForHandle = async (handle, title, price, compare, url) => {
      qaProduct = null;
      qaTitle.textContent = title || '';
      if (compare) {
        qaPrice.innerHTML = '<span class="nola-qa__price-sale"></span> <s class="nola-qa__price-compare"></s>';
        qaPrice.querySelector('.nola-qa__price-sale').textContent = price || '';
        qaPrice.querySelector('.nola-qa__price-compare').textContent = compare;
      } else {
        qaPrice.textContent = price || '';
      }
      qaOptions.innerHTML = '<span class="nola-qa__loading">…</span>';
      qaAdd.disabled = true;
      qaAdd.textContent = 'Select options';
      qaMsg.textContent = '';
      if (qaDetails) qaDetails.href = url || '#';
      if (qaImage) qaImage.src = '';
      openQa();
      try {
        const res = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('fetch failed');
        qaProduct = await res.json();
        qaOptCount = qaProduct.variants[0].options.length;
        qaOptNames = (qaProduct.options || []).map((o) => (typeof o === 'string' ? o : o.name));
        if (qaOptNames.length !== qaOptCount) qaOptNames = qaProduct.variants[0].options.map((_, i) => 'Option ' + (i + 1));
        qaColorIdx = qaOptNames.findIndex(isColorName);
        qaValuesByIndex = [];
        for (let i = 0; i < qaOptCount; i++) {
          const seen = [];
          qaProduct.variants.forEach((v) => { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
          qaValuesByIndex.push(seen);
        }
        qaColorImg = {};
        if (qaColorIdx >= 0) {
          qaProduct.variants.forEach((v) => {
            const cv = v.options[qaColorIdx];
            if (!qaColorImg[cv] && v.featured_image && v.featured_image.src) qaColorImg[cv] = v.featured_image.src;
          });
        }
        qaSelected = qaValuesByIndex.map((vals) => (vals.length === 1 ? vals[0] : null));
        renderQa();
      } catch (err) {
        qaOptions.innerHTML = '';
        qaMsg.textContent = 'Could not load options.';
        if (qaDetails) qaDetails.href = url || '#';
      }
    };

    // open the modal from a card bag button
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-nola-quick-choose]');
      if (!btn || !qa) return;
      e.preventDefault();
      e.stopPropagation();
      openModalForHandle(btn.dataset.productHandle, btn.dataset.productTitle, btn.dataset.productPrice, btn.dataset.productComparePrice, btn.dataset.productUrl);
    });

    // select an option value inside the modal
    if (qaOptions) qaOptions.addEventListener('click', (e) => {
      const vb = e.target.closest('.nola-qa__chip, .nola-qa__swatch');
      if (!vb || vb.disabled) return;
      const idx = Number(vb.dataset.optIdx);
      const value = vb.dataset.optValue;
      qaSelected[idx] = (qaSelected[idx] === value ? null : value);
      renderQa();
    });

    // add to bag
    if (qaAdd) qaAdd.addEventListener('click', async () => {
      const mv = matchedVariant();
      if (!mv || !mv.available) return;
      qaAdd.disabled = true;
      qaMsg.textContent = 'Adding…';
      try {
        await nolaAddToCart(mv.id, { productId: qaProduct && qaProduct.id, productTitle: qaProduct && qaProduct.title });
        closeQa();
      } catch (err) {
        console.error('[nola] quick-add error', err);
        qaMsg.textContent = 'Sorry, that didn’t work. Try again.';
        qaAdd.disabled = false;
      }
    });

    /* ---------- Load more (infinite scroll) ---------- */
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-nola-load-more]');
      if (!btn) return;
      const url = btn.dataset.nextUrl;
      if (!url) return;
      btn.disabled = true;
      const label = btn.querySelector('.nola-coll__loadmore-label');
      const originalLabel = label ? label.textContent : '';
      if (label) label.textContent = 'Loading…';

      try {
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('Load more failed');
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = doc.querySelector('[data-nola-grid]');
        const grid = btn.closest('section')?.querySelector('[data-nola-grid]');
        if (!newGrid || !grid) throw new Error('Grid not found');
        Array.from(newGrid.children).forEach((node) => grid.appendChild(node));
        window.NolaWishlist?.sync(grid);
        initGalleries(grid);

        const newBtn = doc.querySelector('[data-nola-load-more]');
        const wrap = btn.parentElement;
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          const newProgress = newBtn.querySelector('[data-nola-progress]')?.textContent || '';
          const progressEl = btn.querySelector('[data-nola-progress]');
          if (progressEl) progressEl.textContent = newProgress.trim();
        } else {
          btn.remove();
          const endLabel = doc.querySelector('.nola-coll__loadmore-end');
          if (endLabel && wrap) wrap.appendChild(endLabel);
        }
      } catch (err) {
        console.error('[nola] load-more error', err);
        if (label) label.textContent = originalLabel;
      } finally {
        btn.disabled = false;
        if (label && label.textContent === 'Loading…') label.textContent = originalLabel;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nolaPdpInit) return;
    window.__nolaPdpInit = true;

    const moneyFormat = (cents, currency) => {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
        }).format(cents / 100);
      } catch {
        return (cents / 100).toFixed(2);
      }
    };

    // Rounded to a whole unit, no decimals — used for the compare-at price.
    const moneyFormatRounded = (cents, currency) => {
      const whole = Math.round(cents / 100);
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(whole);
      } catch {
        return String(whole);
      }
    };

    document.querySelectorAll('[data-nola-pdp]').forEach((root) => {
      const variantsEl = root.querySelector('[data-nola-variants]');
      if (!variantsEl) return;
      let variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch {}

      const variantMediaEl = root.querySelector('[data-nola-variant-media]');
      let variantMedia = {};
      try { variantMedia = JSON.parse(variantMediaEl?.textContent || '{}'); } catch {}
      const gallery = root.querySelector('[data-nola-gallery]');
      const slides = gallery ? Array.from(gallery.querySelectorAll('.nola-pdp__slide')) : [];
      const thumbs = Array.from(root.querySelectorAll('[data-nola-thumb]'));
      const prevBtn = root.querySelector('[data-nola-gallery-prev]');
      const nextBtn = root.querySelector('[data-nola-gallery-next]');

      const scrollToSlide = (slide) => {
        if (!gallery || !slide) return;
        gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      };

      const scrollGalleryToVariant = (variantId) => {
        if (!gallery || !variantId) return;
        const mediaId = variantMedia[String(variantId)];
        if (!mediaId) return;
        scrollToSlide(gallery.querySelector(`.nola-pdp__slide[data-media-id="${mediaId}"]`));
      };

      const currentSlideIndex = () => {
        if (!gallery || !slides.length) return 0;
        const left = gallery.scrollLeft;
        let best = 0, bestDelta = Infinity;
        slides.forEach((s, i) => {
          const delta = Math.abs(s.offsetLeft - gallery.offsetLeft - left);
          if (delta < bestDelta) { bestDelta = delta; best = i; }
        });
        return best;
      };

      const updateGalleryUi = () => {
        const idx = currentSlideIndex();
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
        if (prevBtn) prevBtn.setAttribute('aria-disabled', idx <= 0 ? 'true' : 'false');
        if (nextBtn) nextBtn.setAttribute('aria-disabled', idx >= slides.length - 1 ? 'true' : 'false');
      };

      if (gallery && slides.length > 1) {
        gallery.addEventListener('scroll', () => {
          window.requestAnimationFrame(updateGalleryUi);
        }, { passive: true });

        prevBtn?.addEventListener('click', () => {
          const idx = currentSlideIndex();
          scrollToSlide(slides[Math.max(0, idx - 1)]);
        });
        nextBtn?.addEventListener('click', () => {
          const idx = currentSlideIndex();
          scrollToSlide(slides[Math.min(slides.length - 1, idx + 1)]);
        });
        thumbs.forEach((t) => {
          t.addEventListener('click', () => {
            const idx = Number(t.dataset.slideIndex) || 0;
            scrollToSlide(slides[idx]);
          });
        });

        updateGalleryUi();
      }

      const form = root.querySelector('.nola-pdp__form');
      const idInput = root.querySelector('[data-nola-variant-id]');
      const submit = root.querySelector('[data-nola-submit]');
      const submitLabel = root.querySelector('[data-nola-submit-label]');
      const priceCurrent = root.querySelector('[data-nola-price-current]');
      const priceCompare = root.querySelector('[data-nola-price-compare]');
      const priceDiscount = root.querySelector('[data-nola-price-discount]');
      const bundlePrice = root.querySelector('[data-nola-bundle-price]');
      const optionLabels = root.querySelectorAll('[data-nola-option-value]');
      const optionFieldsets = root.querySelectorAll('.nola-pdp__option');
      const desktopPanels = root.querySelector('[data-nola-desktop-info-panels]');

      // Sticky ATC mirrors the main submit's state
      const sticky = root.querySelector('[data-nola-sticky]');
      const stickyCta = root.querySelector('[data-nola-sticky-cta]');
      const stickyLabel = root.querySelector('[data-nola-sticky-label]');
      const stickyPrice = root.querySelector('[data-nola-sticky-price]');

      const numOptions = optionFieldsets.length;

      const initDesktopPanels = () => {
        if (!desktopPanels || !window.matchMedia) return;

        const desktopQuery = window.matchMedia('(min-width: 750px)');
        const panelSelectors = [
          '.nola-pdp-bundle',
          '.nola-pdp-ugc',
          '.nola-pdp-accordions',
        ];
        const panels = [];

        const collectPanels = () => {
          document.querySelectorAll(panelSelectors.join(',')).forEach((panel) => {
            const host = panel.closest('.shopify-section') || panel;
            if (root.contains(host) || panels.some((item) => item.node === host)) return;
            const marker = document.createComment('nola-pdp-desktop-panel');
            host.parentNode.insertBefore(marker, host);
            panels.push({ node: host, marker });
          });
        };

        const mountPanels = () => {
          collectPanels();
          panels.forEach(({ node }) => desktopPanels.appendChild(node));
          root.classList.toggle('nola-pdp--desktop-panels-mounted', panels.length > 0);
        };

        const restorePanels = () => {
          panels.forEach(({ node, marker }) => {
            if (marker.parentNode) marker.parentNode.insertBefore(node, marker.nextSibling);
          });
          root.classList.remove('nola-pdp--desktop-panels-mounted');
        };

        const syncPanels = () => {
          if (desktopQuery.matches) {
            mountPanels();
          } else {
            restorePanels();
          }
        };

        syncPanels();
        desktopQuery.addEventListener?.('change', syncPanels);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDesktopPanels, { once: true });
      } else {
        initDesktopPanels();
      }

      // Direct AJAX add-to-cart. Mirrors Horizon's product-form-component
      // handleSubmit (assets/product-form.js) but stripped of the framework
      // wiring that wasn't initialising on this custom PDP.
      // Size sheet — opens when user clicks ATC without picking all options.
      const sizeSheet = root.querySelector('[data-nola-size-sheet]');
      const sizeSheetGrid = sizeSheet?.querySelector('[data-nola-size-sheet-options]');
      const sizeSheetTitle = sizeSheet?.querySelector('[data-nola-size-sheet-title]');
      let lastFocusBeforeSheet = null;

      const populateSheet = (fieldset) => {
        if (!sizeSheet || !sizeSheetGrid || !fieldset) return false;
        sizeSheetGrid.innerHTML = '';
        const optionName = fieldset.querySelector('.nola-pdp__option-name')?.textContent?.trim() || 'Size';
        if (sizeSheetTitle) sizeSheetTitle.textContent = `Select a ${optionName.replace(/:$/, '')}`;
        const inputs = fieldset.querySelectorAll('input[data-nola-option-input]');
        inputs.forEach((input) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nola-pdp__size-sheet-btn';
          btn.textContent = input.value;
          btn.dataset.value = input.value;
          btn.dataset.position = input.dataset.optionPosition || '';
          if (input.disabled) {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          }
          if (input.checked) btn.setAttribute('aria-pressed', 'true');
          btn.addEventListener('click', () => {
            if (btn.disabled) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            closeSizeSheet();
            // If all options are now selected, auto-submit the form (add to cart).
            if (allSelected(getSelectedValues()) && form) {
              setTimeout(() => {
                if (form.requestSubmit) form.requestSubmit();
                else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
              }, 60);
            }
          });
          sizeSheetGrid.appendChild(btn);
        });
        return inputs.length > 0;
      };

      const findFirstUnpickedFieldset = () => {
        const map = getSelectedValues();
        for (const fs of optionFieldsets) {
          const pos = Number(fs.dataset.optionPosition);
          if (!map[pos]) return fs;
        }
        return null;
      };

      const openSizeSheet = () => {
        if (!sizeSheet) return false;
        const fs = findFirstUnpickedFieldset();
        if (!fs) return false;
        if (!populateSheet(fs)) return false;
        lastFocusBeforeSheet = document.activeElement;
        sizeSheet.hidden = false;
        sizeSheet.setAttribute('aria-hidden', 'false');
        // Force a reflow before adding the open class so the slide animation runs
        // even when going from hidden -> open in the same tick.
        // eslint-disable-next-line no-unused-expressions
        sizeSheet.offsetHeight;
        requestAnimationFrame(() => sizeSheet.classList.add('is-open'));
        document.body.style.overflow = 'hidden';
        return true;
      };

      const closeSizeSheet = () => {
        if (!sizeSheet) return;
        sizeSheet.classList.remove('is-open');
        sizeSheet.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setTimeout(() => {
          if (!sizeSheet.classList.contains('is-open')) sizeSheet.hidden = true;
          if (lastFocusBeforeSheet && typeof lastFocusBeforeSheet.focus === 'function') {
            lastFocusBeforeSheet.focus();
          }
        }, 320);
      };

      sizeSheet?.addEventListener('click', (e) => {
        if (e.target.closest('[data-nola-size-sheet-close]')) closeSizeSheet();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sizeSheet?.classList.contains('is-open')) closeSizeSheet();
      });

      if (form) {
        form.addEventListener('submit', async (e) => {
          // No size yet — open the sheet instead of submitting.
          const map = getSelectedValues();
          if (!allSelected(map)) {
            e.preventDefault();
            openSizeSheet();
            return;
          }
          if (submit && submit.disabled) return;
          e.preventDefault();
          if (submit) submit.disabled = true;

          try {
            const fd = new FormData(form);
            const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
              .map((el) => el.dataset.sectionId)
              .filter(Boolean);
            if (sectionIds.length) fd.append('sections', sectionIds.join(','));
            fd.append('sections_url', window.location.pathname);

            const cartAddUrl = (window.Theme?.routes?.cart_add_url) || '/cart/add';
            const addRes = await fetch(cartAddUrl, {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/javascript',
              },
              body: fd,
            });
            const data = await addRes.json();
            if (!addRes.ok || data.status) {
              throw new Error(data.description || data.message || 'add-to-cart failed');
            }

            const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            window.NolaPostHog?.trackAddToCart({
              addedItem: data,
              cart,
              addedFrom: 'pdp',
            });

            // 1. Refresh every cart-items-component on the page from the
            //    sections payload that came back with /cart/add.
            if (data.sections) {
              document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
                const html = data.sections[el.dataset.sectionId];
                if (!html) return;
                try {
                  const wrapper = document.createElement('div');
                  wrapper.innerHTML = html;
                  const incoming = wrapper.querySelector(`cart-items-component[data-section-id="${el.dataset.sectionId}"]`)
                    || wrapper.querySelector('cart-items-component');
                  if (incoming) {
                    el.innerHTML = incoming.innerHTML;
                  }
                } catch (refreshErr) {
                  console.warn('[nola] cart drawer refresh', refreshErr);
                }
              });
            }

            // 2. Fire cart:update so any other listeners (header badge, etc.)
            //    react. Bubble it from the form so it travels up the tree.
            form.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: { source: 'nola-pdp', sections: data.sections, itemCount: cart.item_count },
              },
            }));
            document.dispatchEvent(new CustomEvent('nola:cart:updated', { detail: cart }));

            window.NolaCart?.open();
          } catch (err) {
            console.error('[nola] PDP add-to-cart', err);
          } finally {
            if (submit) submit.disabled = false;
            wrappedUpdate?.();
          }
        });
      }

      const labels = {
        atc:         submit?.dataset.atcLabel       || 'Add to cart',
        select:      submit?.dataset.selectLabel    || 'Select a Size',
        soldOut:     submit?.dataset.soldOutLabel   || 'Sold out',
        unavailable: submit?.dataset.unavailableLabel || 'Unavailable',
      };

      const getSelectedValues = () => {
        const map = {};
        optionFieldsets.forEach((f) => {
          const pos = Number(f.dataset.optionPosition);
          const checked = f.querySelector('input[data-nola-option-input]:checked');
          map[pos] = checked ? checked.value : null;
        });
        return map;
      };

      const allSelected = (map) => {
        for (let i = 1; i <= numOptions; i++) if (!map[i]) return false;
        return true;
      };

      const findVariant = (selectedMap) => {
        const arr = [];
        for (let i = 1; i <= numOptions; i++) arr.push(selectedMap[i]);
        return variants.find((v) => v.options.every((o, i) => o === arr[i]));
      };

      const update = () => {
        const selectedMap = getSelectedValues();

        // Update legend selected-value labels
        optionLabels.forEach((el) => {
          const pos = Number(el.dataset.nolaOptionValue);
          el.textContent = selectedMap[pos] || '';
        });

        if (!allSelected(selectedMap)) {
          // Keep the button clickable so it can open the size sheet.
          submit.disabled = false;
          if (submitLabel) submitLabel.textContent = labels.atc;
          return;
        }

        const v = findVariant(selectedMap);
        if (!v) {
          submit.disabled = true;
          if (submitLabel) submitLabel.textContent = labels.unavailable;
          return;
        }

        idInput.value = v.id;

        // URL update for shareability
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);

        // Price
        if (priceCurrent) priceCurrent.textContent = moneyFormat(v.price);
        if (bundlePrice) bundlePrice.textContent = moneyFormat(Math.round(v.price * 0.8));
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (priceCompare) {
            priceCompare.textContent = moneyFormatRounded(v.compare_at_price);
            priceCompare.hidden = false;
          }
          if (priceDiscount) {
            const off = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
            priceDiscount.textContent = `${off}% OFF`;
            priceDiscount.hidden = false;
          }
        } else {
          if (priceCompare) priceCompare.hidden = true;
          if (priceDiscount) priceDiscount.hidden = true;
        }

        submit.disabled = !v.available;
        if (submitLabel) {
          submitLabel.textContent = v.available ? labels.atc : labels.soldOut;
        }
      };

      // Mirror main submit state onto sticky CTA after each update
      const syncSticky = () => {
        if (!stickyCta || !stickyLabel) return;
        const text = submitLabel ? submitLabel.textContent : labels.atc;
        stickyLabel.textContent = text;
        // Keep the sticky CTA clickable in the "Select a Size" state so we can scroll
        // to the picker. Only disable when truly unactionable (sold out / unavailable).
        const mainDisabled = submit ? submit.disabled : false;
        const isSelectState = text === labels.select;
        stickyCta.disabled = mainDisabled && !isSelectState;
        if (stickyPrice && priceCurrent) {
          const compareHtml = priceCompare && !priceCompare.hidden && priceCompare.textContent
            ? `<s>${priceCompare.textContent}</s> `
            : '';
          stickyPrice.innerHTML = `${compareHtml}<span>${priceCurrent.textContent}</span>`;
        }
      };
      const origUpdate = update;
      const wrappedUpdate = () => { origUpdate(); syncSticky(); };

      // Init label state on load
      wrappedUpdate();

      form.addEventListener('change', (e) => {
        if (!e.target.matches('[data-nola-option-input]')) return;
        wrappedUpdate();

        // Scroll the gallery to the variant image whose option set matches what's
        // currently selected. If not all options are picked yet (e.g. user clicks
        // a color before a size), fall back to the first variant matching the
        // changed option's value.
        const selectedMap = getSelectedValues();
        let target = allSelected(selectedMap) ? findVariant(selectedMap) : null;
        if (!target) {
          const fs = e.target.closest('.nola-pdp__option');
          const pos = fs ? Number(fs.dataset.optionPosition) : 0;
          if (pos) {
            target = variants.find((v) => v.options[pos - 1] === e.target.value);
          }
        }
        if (target) scrollGalleryToVariant(target.id);
      });

      // Smooth-scroll to the first unpicked option fieldset
      const scrollToFirstUnpicked = () => {
        const map = getSelectedValues();
        for (let i = 1; i <= numOptions; i++) {
          if (!map[i]) {
            const fs = root.querySelector(`.nola-pdp__option[data-option-position="${i}"]`);
            if (fs) {
              fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
              fs.animate(
                [{ outline: '2px solid #000000' }, { outline: '2px solid transparent' }],
                { duration: 800, iterations: 2 }
              );
            }
            return true;
          }
        }
        return false;
      };

      // Sticky CTA: open size sheet if not all selected, otherwise submit
      if (stickyCta && form) {
        stickyCta.addEventListener('click', () => {
          const map = getSelectedValues();
          if (!allSelected(map)) {
            openSizeSheet();
            return;
          }
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      // Show sticky bar only when the user has scrolled BELOW the main submit
      // (i.e. the button is above the viewport). Hides when at/above the button.
      if (sticky && submit) {
        const updateStickyVisibility = () => {
          const rect = submit.getBoundingClientRect();
          // Button is fully above the visible viewport
          const isPastButton = rect.bottom < 0;
          sticky.classList.toggle('is-visible', isPastButton);
        };
        updateStickyVisibility();
        window.addEventListener('scroll', updateStickyVisibility, { passive: true });
        window.addEventListener('resize', updateStickyVisibility);
      }
    });

    /* Wishlist behavior is handled globally by assets/nola-wishlist.js */

    /* ---- Order-within countdown ---- */
    const formatHM = (ms) => {
      const totalMin = Math.max(0, Math.floor(ms / 60000));
      const h = Math.floor(totalMin / 60);
      const m = totalMin % 60;
      if (h <= 0) return `${m} Min${m === 1 ? '' : 's'}`;
      return `${h} Hr${h === 1 ? '' : 's'} ${m} Min${m === 1 ? '' : 's'}`;
    };
    const dateLong = (d) =>
      d.toLocaleDateString(undefined, { day: 'numeric', month: 'long' });

    document.querySelectorAll('[data-nola-countdown]').forEach((el) => {
      const cutoffHour = Number(el.dataset.cutoffHour) || 16;
      const days = Number(el.dataset.deliveryDays) || 5;
      const text = el.querySelector('[data-nola-countdown-text]');
      const tick = () => {
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
        const ms = cutoff - now;

        const delivery = new Date(now);
        delivery.setDate(delivery.getDate() + days);

        text.innerHTML = `Order within <strong>${formatHM(ms)}</strong> to receive ${dateLong(delivery)}`;
      };
      tick();
      setInterval(tick, 30000);
    });
  })();

  /* Kiwi relocator removed: size guide is now native (snippets/nola-size-guide.liquid) */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-pdp-reviews-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', (event) => {
      const collapseButton = event.target.closest('[data-nola-review-collapse-toggle]');
      if (collapseButton) {
        const wrap = collapseButton.closest('[data-nola-review-collapse]');
        if (!wrap) return;
        const collapsed = wrap.dataset.collapsed === 'true';
        wrap.dataset.collapsed = collapsed ? 'false' : 'true';
        collapseButton.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        collapseButton.textContent = collapsed ? 'Read Less' : 'Read More';
        return;
      }

      const moreButton = event.target.closest('[data-nola-review-more]');
      if (moreButton) {
        const list = moreButton.previousElementSibling;
        if (!list || !list.matches('[data-nola-review-list]')) return;
        const step = Number(list.dataset.step) || 3;
        Array.from(list.querySelectorAll('[data-nola-review-card][hidden]'))
          .slice(0, step)
          .forEach((card) => card.removeAttribute('hidden'));
        if (!list.querySelector('[data-nola-review-card][hidden]')) moreButton.hidden = true;
        return;
      }

      const helpful = event.target.closest('[data-nola-review-helpful]');
      if (helpful) {
        if (helpful.dataset.voted === 'true') return;
        const count = helpful.querySelector('[data-nola-review-helpful-count]');
        if (count) count.textContent = String((Number(count.textContent) || 0) + 1);
        helpful.dataset.voted = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    // Read more / less for the summary paragraph
    const collapseBtn = e.target.closest('[data-nola-collapse-toggle]');
    if (collapseBtn) {
      const wrap = collapseBtn.closest('[data-nola-collapse]');
      if (wrap) {
        const collapsed = wrap.dataset.collapsed === 'true';
        wrap.dataset.collapsed = collapsed ? 'false' : 'true';
        collapseBtn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        collapseBtn.textContent = collapsed ? 'Read Less' : 'Read More';
      }
      return;
    }

    // Show more reviews
    const moreBtn = e.target.closest('[data-nola-reviews-more]');
    if (moreBtn) {
      const list = moreBtn.previousElementSibling;
      if (!list || !list.matches('[data-nola-reviews-list]')) return;
      const step = Number(list.dataset.step) || 3;
      const hidden = list.querySelectorAll('[data-nola-review][hidden]');
      Array.from(hidden).slice(0, step).forEach((el) => el.removeAttribute('hidden'));
      const visible = list.querySelectorAll('[data-nola-review]:not([hidden])').length;
      list.dataset.visible = visible;
      if (list.querySelectorAll('[data-nola-review][hidden]').length === 0) {
        moreBtn.hidden = true;
      }
      return;
    }

    // Helpfulness vote — local-only counter, persists per session
    const voteBtn = e.target.closest('[data-nola-helpful-vote]');
    if (voteBtn) {
      const dir = voteBtn.dataset.nolaHelpfulVote;
      const wrap = voteBtn.closest('[data-nola-helpful]');
      if (!wrap) return;
      if (wrap.dataset.voted) return; // one vote per review per session
      const target = dir === 'up'
        ? wrap.querySelector('[data-nola-helpful-up]')
        : wrap.querySelector('[data-nola-helpful-down]');
      if (target) target.textContent = String((Number(target.textContent) || 0) + 1);
      wrap.dataset.voted = dir;
      voteBtn.classList.add('is-voted');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nolaUgcInit) return;
    window.__nolaUgcInit = true;

    const extractYoutubeId = (url) => {
      if (!url) return null;
      const patterns = [
        /youtube\.com\/shorts\/([\w-]{6,})/,
        /youtu\.be\/([\w-]{6,})/,
        /youtube\.com\/watch\?v=([\w-]{6,})/,
        /youtube\.com\/embed\/([\w-]{6,})/,
      ];
      for (const re of patterns) {
        const m = url.match(re);
        if (m) return m[1];
      }
      return null;
    };
    const extractVimeoId = (url) => {
      const m = url && url.match(/vimeo\.com\/(\d+)/);
      return m ? m[1] : null;
    };

    // Track play/pause state on inline <video> elements so the button can show the right icon.
    const wireVideo = (video) => {
      const tile = video.closest('.nola-pdp-ugc__tile');
      if (!tile) return;
      const sync = () => {
        tile.dataset.playing = !video.paused && !video.ended ? 'true' : 'false';
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      sync();
    };
    document.querySelectorAll('[data-nola-ugc-video]').forEach(wireVideo);

    document.addEventListener('click', (e) => {
      const tile = e.target.closest('.nola-pdp-ugc__tile');
      if (!tile) return;
      // Ignore clicks on scrollbar/etc — only handle clicks on the tile body.
      if (!e.target.closest('[data-nola-ugc-play]') && !e.target.closest('[data-nola-ugc-video]')) {
        // Default: a click anywhere on the tile (poster/play btn) toggles the video.
      }

      const video = tile.querySelector('[data-nola-ugc-video]');
      if (video) {
        // Inline uploaded video: toggle play/pause.
        if (video.paused || video.ended) {
          // Unmute on first user-initiated play so they hear audio.
          video.muted = false;
          video.play().catch(() => {
            // Browser blocked unmuted autoplay — retry muted so something still plays.
            video.muted = true;
            video.play().catch(() => {});
          });
        } else {
          video.pause();
        }
        return;
      }

      // External URL fallback (YouTube/Vimeo/.mp4) — load on first click.
      if (tile.dataset.playing === 'true') return;
      const url = tile.dataset.videoUrl;
      if (!url) return;
      const yt = extractYoutubeId(url);
      const vm = extractVimeoId(url);
      let mediaEl;
      if (yt) {
        mediaEl = document.createElement('iframe');
        mediaEl.src = `https://www.youtube.com/embed/${yt}?autoplay=1&playsinline=1&rel=0&modestbranding=1`;
        mediaEl.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        mediaEl.allowFullscreen = true;
      } else if (vm) {
        mediaEl = document.createElement('iframe');
        mediaEl.src = `https://player.vimeo.com/video/${vm}?autoplay=1&playsinline=1`;
        mediaEl.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        mediaEl.allowFullscreen = true;
      } else {
        mediaEl = document.createElement('video');
        mediaEl.autoplay = true;
        mediaEl.playsInline = true;
        mediaEl.controls = false;
        mediaEl.src = url;
      }
      mediaEl.classList.add('nola-pdp-ugc__media');
      const poster = tile.querySelector('.nola-pdp-ugc__poster');
      if (poster) poster.replaceWith(mediaEl);
      const btn = tile.querySelector('[data-nola-ugc-play]');
      if (btn) btn.remove();
      tile.dataset.playing = 'true';
      if (mediaEl.tagName === 'VIDEO') mediaEl.play().catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nola-pdp-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nola-upsell]').forEach((root) => {
      const track = root.querySelector('[data-nola-upsell-track]');
      const prev = root.querySelector('[data-nola-upsell-prev]');
      const next = root.querySelector('[data-nola-upsell-next]');
      const progress = root.querySelector('[data-nola-upsell-progress]');
      if (!track) return;

      const items = Array.from(track.children);
      if (items.length === 0) return;

      // Clone items once so the track can wrap seamlessly
      const cloneCount = Math.min(items.length, 8);
      for (let i = 0; i < cloneCount; i++) {
        const clone = items[i].cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        track.appendChild(clone);
      }

      const stepWidth = () => {
        const first = items[0];
        if (!first) return 240;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const realWidth = () => stepWidth() * items.length;

      // Sync wishlist hearts on render — clones were just appended.
      window.NolaWishlist?.sync(root);

      const updateProgress = () => {
        if (!progress) return;
        const w = realWidth();
        if (!w) return;
        const x = ((track.scrollLeft % w) + w) % w;
        const pct = (x / w) * 100;
        progress.style.transform = `translateX(${pct}%)`;
      };

      // Loop wrap: when user scrolls past the real set, jump back silently
      const wrap = () => {
        const w = realWidth();
        if (!w) return;
        if (track.scrollLeft >= w) {
          track.scrollLeft -= w;
        } else if (track.scrollLeft < 0) {
          track.scrollLeft += w;
        }
      };

      track.addEventListener('scroll', () => {
        wrap();
        updateProgress();
      }, { passive: true });

      const move = (dir) => {
        const step = stepWidth();
        track.scrollBy({ left: step * dir, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => move(-1));
      if (next) next.addEventListener('click', () => move(1));

      updateProgress();
    });

    // Quick-add bag → existing nola cart hook
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-nola-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: fd,
        });
        if (!res.ok) throw new Error('Quick-add failed');
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartRes.json();
        window.NolaPostHog?.trackAddToCart({
          addedItem: {
            variant_id: variantId,
            product_id: btn.dataset.productId,
            product_title: btn.dataset.productTitle,
            quantity: 1,
          },
          cart,
          addedFrom: 'cross_sell',
        });
        document.dispatchEvent(new CustomEvent('nola:cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { source: 'nola-upsell-quick-add' } },
        }));
        window.NolaCart?.open();
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1200);
      } catch (err) {
        console.error('[nola] upsell quick-add', err);
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
